import React, { Fragment, useContext, useState, useEffect } from 'react';

import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';
import AuthState from '../../context/autenticacion/authContext';

import './Select.css';
import Select from './Select';

const FormTarea = () => {

    // Extraer si un proyecto está activo o una vista de un proyecto fue seleccionada
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, obtenerUltimosCambios, guardarUltimoCambio, } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const {
        errorcampo,
        tareaseleccionada,
        descripcionseleccionada,
        tareaactual,
        vertarea,
        formulariodescripcion,
        agregarTarea,
        validarCampo,
        obtenerTareas,
        actualizarTarea,
        limpiarTarea,
        tareaActual,
        obtenerDescripciones,
        agregarDescripcion,
        actualizarDescripcion,
        limpiarDescripcion,
        formularioDescripcion } = tareasContext;

    // Extraer users del context
    const barrapplContext = useContext(barraprincipalContext);
    const { cuentas, obtenerUsuarios } = barrapplContext;

    // Extraer usuario logeado
    const authState = useContext(AuthState);
    const { usuario } = authState;

    // Effect que detecta si hay una tarea seleccionada o descripcion seleccionada
    useEffect(() => {
        if(descripcionseleccionada !== null){
            guardarDescripcion(descripcionseleccionada);
        }else {
            guardarDescripcion({
                contenido: ''
            })
        }
        if(tareaseleccionada !== null) {
            guardarTarea(tareaseleccionada);
        }else {
            guardarTarea({
                nombre: '',
                para: '',
                paraId: ''
            });
        }
        obtenerUsuarios();
        // eslint-disable-next-line
    }, [tareaseleccionada, descripcionseleccionada]);

    // States del formulario
    const [ tarea, guardarTarea ] = useState({
        nombre: '',
        para: '',
        paraId: ''
    });
    const [ descripcion, guardarDescripcion ] = useState({
        contenido: ''
    });

    if(usuario) {
        if(!vertarea) {
            if(usuario.rol !== 'Administrador') return null;
        }
    }

    // Extraer valores de los states
    const { nombre, para } = tarea;
    const { contenido } = descripcion;

    // Array destructuring para extraer el proyecto actual
    const [ proyectoActual ] = proyecto;

    // Leer los valores del formulario
    const handleChangeNombre = e => {
        guardarTarea({
            ...tarea,
            [e.target.name]: e.target.value
        });
    }
    const handleChangePara = (id, name) => {
        guardarTarea({
            ...tarea,
            para: name,
            paraId: id
        });
    }
    const handleChangeDescripcion = e => {
        guardarDescripcion({
            ...descripcion,
            contenido: e.target.value
        })
    }

    // Seleccionando los elementos del select
    const select = document.querySelector('.selected');
    const contenedorOpciones = document.querySelector('.options-container');
    const options = document.querySelectorAll('.option');
    
    // Cuando de click en el select, abrir las opciones
    const abrirSelect = () => {
        const contenedorOpcionesFun = document.querySelector('.options-container');
        contenedorOpcionesFun.classList.toggle('active');
    }

    // Cuando una opcion sea seleccionada
    options.forEach(option => {
        option.addEventListener('click', () => {
            // Mostrarla en el select (opcional)
            if(option.querySelector('p') != null){
                select.innerHTML = option.querySelector('p').innerHTML;
            }
        });
        // Esconder las opciones
        contenedorOpciones.classList.remove('active');
    });

    const onSubmit = e => {
        e.preventDefault();
        
        // Si está en la vista de una tarea
        if(formulariodescripcion){
            if(descripcionseleccionada === null) {
                // Validar
                if(contenido.trim() === '') {
                    validarCampo();
                    return;
                }

                // Agregar la nueva descripcion al state de descripciones
                descripcion.tarea = tareaactual._id;
                descripcion.realizadaPor = 'Ezequiel Lujan';
                agregarDescripcion(descripcion);
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tareaactual.nombre, 'Agregó una descripción');
            }else{
                // Editar la descripcion existente
                actualizarDescripcion(descripcion);
                limpiarDescripcion();
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tareaactual.nombre, 'Actualizó una descripción');
            }
            // Obtener y filtrar las descripciones de la tarea actual
            obtenerDescripciones(tareaactual._id);
        }else{ // Si está en el listado de tareas
            if(tareaseleccionada === null) {
                // Validar
                if(nombre.trim() === '' || para.trim() === '') {
                    validarCampo();
                    return;
                }
                
                // Agregar la nueva tarea al state de tareas
                tarea.proyecto = proyectoActual._id;
                agregarTarea(tarea);
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Agregó la tarea');
            }else {
                // Editar la tarea existente
                actualizarTarea(tarea);
                // Si está viendo determinada tarea
                if(vertarea) {
                    tareaActual(tarea); // Cargar el state tareaactual
                    formularioDescripcion(true); // Aparecer form descripciones
                }
                // Elimina tareaseleccionada del state
                limpiarTarea();
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Actualizó la tarea');
            }
        }

        // Obtener y filtrar las tareas del proyecto actual
        obtenerTareas(proyectoActual._id);
        
        // Obtener y filtrar los ultimos cambios del proyecto
        obtenerUltimosCambios(proyectoActual._id);

        // Reiniciar el form
        guardarTarea({
            nombre: '',
            para: '',
            paraId: ''
        });
        guardarDescripcion({
            contenido: ''
        });
    }
    
    return (
        <Fragment>
            <form
                onSubmit={onSubmit}
            >
                {formulariodescripcion ? (
                    <div className="contenedor-input">
                        <textarea 
                            className="input-text"
                            placeholder="Descripción..."
                            autoComplete="off"
                            autoFocus={true}
                            rows="4"
                            name="descripcion"
                            value={contenido}
                            onChange={handleChangeDescripcion}
                        ></textarea>
                    </div>
                ) : ( 
                    <Fragment>
                        <div className="contenedor-input">
                            <input 
                                type="text"
                                className="input-text"
                                placeholder="Nombre tarea..."
                                autoComplete="off"
                                autoFocus={true}
                                name="nombre"
                                value={nombre}
                                onChange={handleChangeNombre}
                            />
                        </div>
                        
                        <div className="contenedor-input">
                            <div className="select-box">
                                <div 
                                    className="selected"
                                    onClick={() => abrirSelect()}
                                    tabIndex="0"
                                >
                                    {para ? para : 'Selecciona un usuario'}
                                </div>
                                <div className="options-container">
                                    {cuentas.map(cuenta => (
                                        <Select
                                            key={cuenta._id}
                                            cuenta={cuenta}
                                            handleChangePara={handleChangePara}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}

                <div className="contenedor-input">
                    <input
                        type="submit"
                        className="btn btn-primario btn-submit btn-block"
                        value={
                            formulariodescripcion ? (
                                descripcionseleccionada ? 'Editar Descripcion' : 'Agregar Descripcion'
                            ) : (
                                tareaseleccionada ? 'Editar Tarea' : 'Agregar Tarea'
                            )
                        }
                    />
                </div>
            </form>
            
            {errorcampo ? (
                formulariodescripcion ? (
                    <p className="mensaje error">La descripción es obligatoria</p> 
                ) : (
                    <p className="mensaje error">Todos los campos son obligatorios</p> 
                )
            ) : null}
            
        </Fragment>
    );
}
 
export default FormTarea;